export default __webpack_public_path__ + "static/media/finalImage.f1ca00a6.png";